import { render, staticRenderFns } from "./SuccessChangePassword.vue?vue&type=template&id=43b92e45&scoped=true&"
import script from "./SuccessChangePassword.vue?vue&type=script&lang=js&"
export * from "./SuccessChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./SuccessChangePassword.vue?vue&type=style&index=0&id=43b92e45&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b92e45",
  null
  
)

export default component.exports